import moment from "moment";

export const getFileExtension = (url) => {
  // Get the last part of the URL after the last '/'
  const filename = url.substring(url.lastIndexOf("/") + 1);

  // Get the file extension by getting the last part of the filename after the last '.'
  const extension = filename.substring(filename.lastIndexOf(".") + 1);

  return extension;
};

export const isObjectEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key]) {
      if (obj[key] === '{"min":0,"max":20000000}') {
      } else {
        return false;
      }
    }
  }
  return true;
};

export function formatDate(date) {
  const now = moment();
  const inputDate = moment(date);

  if (now.isSame(inputDate, "day")) {
    return "Today, " + inputDate.format("hh:mm A");
  } else if (now.subtract(1, "day").isSame(inputDate, "day")) {
    return "Yesterday, " + inputDate.format("hh:mm A");
  } else {
    return inputDate.format("DD/MM/YYYY, hh:mm A");
  }
}

export const timeStringToSeconds = (timeString) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  console.log(hours, minutes, "hours, minutes");

  if (!hours && !minutes) return 10000;
  const totalSeconds = hours * 3600 + minutes * 60;

  return totalSeconds;
};

export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
